import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      width: '88%',
      margin: '0 auto'
    }
  },
  select: {
    height: 40,
    width: '100%',
    backgroundColor: theme.palette.primary.contrastText,
    '& > div': {
      padding: theme.spacing(1, 1.75),
      paddingTop: theme.spacing(1.25),
      fontWeight: 500
    },
    '& input': {
      height: 3,
      color: theme.palette.primary.main
    },
    '& fieldset': {
      height: 45,
      borderColor: theme.palette.primary.main,
      borderRadius: 5
    },
    '& svg': {
      color: theme.palette.primary.main,
      height: 19
    },
    [theme.breakpoints.up('md')]: {
      width: 350
    }
  },
  labelSelect: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    paddingRight: theme.spacing(),
    backgroundColor: theme.palette.primary.contrastText,
    transform: 'translate(14px, 13px) scale(1)',
    '&.error': {
      color: theme.palette.error.main
    }
  },
  helperText: {
    marginLeft: theme.spacing()
  },
  menuContainer: {
    marginTop: theme.spacing(6)
  },
  item: {
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.utils.rgba(theme.palette.secondary.main, 0.64)
    }
  },
  itemSelected: {
    display: 'none'
  }
}))
